import { useState, useEffect } from 'react'
import { bruktbilfinansieringAPI } from '../../../services/api'

export interface BankOption {
  bank_org_nr: string
  bank_name: string
}

export function useBanks() {
  const [banks, setBanks] = useState<BankOption[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    bruktbilfinansieringAPI.getMyBanks()
      .then(res => setBanks(res.data.banks))
      .catch(() => setBanks([]))
      .finally(() => setLoading(false))
  }, [])

  return { banks, loading }
}
